// @flow
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  Typography,
  useMediaQuery,
  DialogContent,
  Dialog,
  Grid,
} from "@mui/material";
import SVGCurvedText from "components/SVGCurvedText";
import { gaugeActions, homeActions } from "actions";
import { Box } from "@mui/system";
// import rightcorner from "assets/images/rightcorner.png";
// import leftcorner from "assets/images/leftcorner.png";
import { LeftCustomSvgIcon, RightCustomSvgIcon } from "helpers/CustomSVGGauge";
import "../../components/Gauge.scss";
import CuverdLightLogo from "assets/images/cuverd-logo-footer.png";
import CuverdDarkLogo from "assets/images/cuverd-logo-header.png";
import SendSavingsPOS from "./SendSavingsPOS";
import ShareHCPApp from "pages/home/ShareHCPApp";

let getSavingsBtn = null;
let couponInterval = null;
let discountInterval = null;

const SearchGaugeView = (props) => {
  const {
    retailData,
    discountDataObj,
    copayPrice,
    copayPriceIsProgress,
    isProgress,
    resetId,
    productDetailId,
    zipData,
    selectedInsurance,
    selectedProduct,
    onSavingsClick,
    storeAppData,
    appQuantity,
    couponDataArray,
    couponLowestPrice,
    discountDataArray,
    updateCouponPrice,
    updateDiscountPrice,
    couponDataIsProgress,
    organizationInfo,
    discountDataIsProgress,
    gaugeInit,
    setGaugeInit,
    retailMessage,
    discountMessage,
    retailDataStatus,
    discountDataStatus,
    showGauge,
    setSavingsBtnAutoForward,
    savingsBtnAutoForward,
    copayPriceReset,
    couponPriceReset,
    hasUserSelectedInsurance,
    openInsurance,
    setTriggerGetSavings = null,
    triggerGetSavings = false,
    couponDataObj,
  } = props;

  useEffect(() => {
    if (
      (!showGauge && getSavingsBtn) ||
      !savingsBtnAutoForward ||
      copayPriceIsProgress ||
      couponDataIsProgress
    ) {
      clearTimeout(getSavingsBtn);
      getSavingsBtn = null;
    }
  }, [
    showGauge,
    savingsBtnAutoForward,
    copayPriceIsProgress,
    couponDataIsProgress,
  ]);

  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );

  const [couponData, setCouponData] = useState({});
  const [discountData, setDiscountData] = useState({});
  const [showCouponPrice, setShowCouponPrice] = useState(false);
  const [showCopayPrice, setShowCopayPrice] = useState(false);
  const [showDiscountPrice, setShowDiscountPrice] = useState(false);
  const [showRetailPrice, setShowRetailPrice] = useState(false);
  const [retailCone, setRetailCone] = useState(false);
  const [discountCone, setDiscountCone] = useState(false);
  const [copayCone, setCopayCone] = useState(false);
  const [couponCone, setCouponCone] = useState(false);
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
   
   const isHCPTemplate =
     organizationInfo?.type?.toLowerCase() === "h" &&
     organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
   const isPOSTemplate =
     organizationInfo?.type?.toLowerCase() === "p" &&
     organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

   const isShowGaugeFlag =
     organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() ===
     "y";

   const [openInfoDialog, setOpenInfoDialog] = useState(false);

   // const [showAlternatives, setShowAlternatives] = useState(false);
   // const [alternateType, setAlternateType] = useState("");

   const fullWidth = "25rem";
   const halfWidth = "12.5rem";
   const mobileFullWidth = "280px";
   const mobileHalfWidth = "140px";
   const poweredByFlag =
     organizationInfo?.colorSchemeJson?.gaugeColor?.poweredByImageType !==
       undefined &&
     organizationInfo?.colorSchemeJson?.gaugeColor?.poweredByImageType !== null;
   let poweredByLogo = null;
   if (poweredByFlag) {
     poweredByLogo =
       organizationInfo?.colorSchemeJson?.gaugeColor?.poweredByImageType ===
       "light"
         ? CuverdLightLogo
         : CuverdDarkLogo;
   }
   const [showShareHCPPopup, setShowShareHCPPopup] = useState(false);
   const [showSharePOSPopup, setShowSharePOSPopup] = useState(false);

   const matchesMinWidth = useMediaQuery("(max-width:500px)");
   // const matches400Width = useMediaQuery("(max-width:400px)");
   // const matchesSmallestWidth = useMediaQuery("(max-width:320px)");
   // const hasUserSelectedInsurance = localStorage.getItem(
   //   "hasUserSelectedInsurance"
   // );

   useEffect(() => {
     storeAppData("brandedInfo", null);
     storeAppData("genericInfo", null);
     storeAppData("alternate", null);

     // return () => {
     //   console.log("getSavingsBtn exit");
     //   clearTimeout(getSavingsBtn);
     //   getSavingsBtn = null;
     // };
   }, []);

   useEffect(() => {
     if (triggerGetSavings) {
       getSavings();
       setTriggerGetSavings(false);
     }
   }, [triggerGetSavings]);

   const showCouponsDataArray = () => {
     let index = 0;
     const couponDataArrayTemp = [...couponDataArray, couponLowestPrice];
     const intervalMethod = () => {
       if (couponDataArrayTemp[index]) {
         setShowCouponPrice(true);
         setCopayCone(false);
         // setCouponCone(true);
         const couponObj = {
           ...couponDataArrayTemp[index],
           index,
           isLast: index === couponDataArrayTemp.length - 1 ? true : false,
         };
         setCouponData(couponObj);

         if (index === couponDataArrayTemp.length - 1) {
           updateCouponPrice(couponObj);
           if (
             parseFloat(copayPrice?.copayPriceMax?.replace("$", "").trim()) <
             parseFloat(
               couponObj?.couponPrice?.replace("$", "").trim() ||
                 couponObj?.discountPrice?.replace("$", "").trim()
             )
           ) {
             setCopayCone(true);
             setCouponCone(false);
             // setShowCouponPrice(false);
           }
           setGaugeInit(false);

           clearInterval(couponInterval);
         }
         index++;
       }
     };

     if (couponDataArrayTemp.length === 1) {
       intervalMethod();
     } else {
       couponInterval = setInterval(() => {
         intervalMethod();
       }, 1500);
     }
   };

   useEffect(() => {
     if (couponCone) {
       if (couponInterval) {
         // resetGauge();
         clearInterval(couponInterval);
       }
       setShowCouponPrice(false);
       updateCouponPrice({});
       setCouponData({});
       clearInterval(couponInterval);

       if (
         !isProgress &&
         !couponDataIsProgress &&
         (couponDataArray.length || couponLowestPrice)
       ) {
         showCouponsDataArray();
       }
     }
   }, [couponCone]);

   useEffect(() => {
     if (!isShowGaugeFlag && couponLowestPrice?.offerId) {
       setCopayCone(false);
       setCouponCone(true);
       //  const couponObj = {
       //    ...couponLowestPrice,
       //    index: 0,
       //    isLast: true,
       //  };
       //  setCouponData(couponObj);
       //  setCopayCone(false);

       //  updateCouponPrice(couponObj);
     }
   }, [couponLowestPrice]);

   const showDiscountsDataArray = () => {
     let index = 0;

     const discountDataArrayTemp = [
       ...discountDataArray,
       discountDataArray[discountDataArray.length - 1],
     ];
     const intervalMethod = () => {
       setCouponCone(false);
       setShowCouponPrice(false);
       setCouponData({});
       if (discountDataArrayTemp[index]) {
         setDiscountData({
           ...discountDataArrayTemp[index],
           index,
           isLast: index === discountDataArrayTemp.length - 1 ? true : false,
         });

         if (index === discountDataArrayTemp.length - 1) {
           updateDiscountPrice({
             ...discountDataArrayTemp[index],
             isLast: true,
             index,
           });
           clearInterval(discountInterval);
         }
         index++;
       }
     };

     if (discountDataArrayTemp.length === 1) {
       intervalMethod();
     } else {
       discountInterval = setInterval(() => {
         intervalMethod();
       }, 1500);
     }
   };

   useEffect(() => {
     if (discountInterval) {
       // resetGauge();
       clearInterval(discountInterval);
     }

     setCouponCone(false);
     setShowCouponPrice(false);
     setCouponData({});

     updateDiscountPrice({});
     setDiscountData({});
     clearInterval(discountInterval);

     if (!discountDataIsProgress && discountDataArray.length) {
       showDiscountsDataArray();
     }
   }, [discountDataArray, discountDataIsProgress]);

   useEffect(() => {
     setCouponCone(false);
     setShowCouponPrice(false);
     setCouponData({});
     clearInterval(couponInterval);
   }, [retailData, discountData, discountDataArray, copayPrice]);

   useEffect(() => {
     resetGauge();
   }, [resetId]);

   useEffect(() => {
     if (gaugeInit && retailCone) {
       setDiscountCone(false);
       setCopayCone(false);
       setCouponCone(false);
       setShowDiscountPrice(false);
       setShowCopayPrice(false);
       setShowCouponPrice(false);
     }
   }, [gaugeInit, retailCone]);

   useEffect(() => {
     if (copayPriceIsProgress) {
       setRetailCone(false);
       setDiscountCone(false);
       setCouponCone(false);
       setCopayCone(true);
     }
   }, [copayPriceIsProgress]);

   useEffect(() => {
     if (
       retailData &&
       discountDataArray &&
       Object.keys(retailData || {}).length &&
       discountDataArray.length &&
       Object.keys(copayPrice || {}).length === 0 &&
       couponDataArray.length === 0 &&
       !copayPriceIsProgress
     ) {
       priceGuage();
     } else if (
       retailData &&
       discountDataArray &&
       Object.keys(retailData).length &&
       discountDataArray.length === 0 &&
       Object.keys(copayPrice).length === 0 &&
       couponDataArray.length === 0 &&
       !copayPriceIsProgress
     ) {
       priceGuageRetail();
     } else if (
       retailData &&
       discountDataArray &&
       Object.keys(retailData || {}).length &&
       discountDataArray.length &&
       Object.keys(copayPrice || {}).length &&
       (couponDataArray.length === 0 || copayPrice?.alternateFlag === "Y")
     ) {
       setRetailCone(false);
       setDiscountCone(false);
       setShowCopayPrice(!copayPriceIsProgress);
       setCouponCone(false);
       setCopayCone(true);
     }

     if (
       !copayPriceIsProgress &&
       retailData &&
       discountDataArray &&
       copayPrice &&
       (couponDataArray || couponLowestPrice !== null) &&
       Object.keys(copayPrice || {}).length &&
       (couponDataArray.length ||
         Object.keys(couponLowestPrice || {}).length) &&
       Object.keys(retailData || {}).length &&
       discountDataArray.length &&
       copayPrice?.alternateFlag === "N"
     ) {
       fullPriceGauge();
     }
   }, [retailData, discountDataArray, copayPrice, couponDataArray]);

   const resetGauge = () => {
     setRetailCone(false);
     setDiscountCone(false);
     setCopayCone(false);
     setCouponCone(false);
     setShowRetailPrice(false);
     setShowDiscountPrice(false);
     setShowCopayPrice(false);
     setShowCouponPrice(false);

     couponPriceReset();
     copayPriceReset();
     setCouponData({});
     setDiscountData({});
     clearInterval(couponInterval);
     clearInterval(discountInterval);
     couponInterval = null;
     discountInterval = null;
     updateDiscountPrice({});
     updateCouponPrice({});
   };

   const priceGuageRetail = () => {
     setTimeout(() => {
       if (selectedProduct && selectedProduct.type === "G") {
         setShowRetailPrice(true);
       } else {
         setRetailCone(true);
         setShowRetailPrice(true);
         setCouponCone(false);
         setShowCouponPrice(false);
       }
     }, 0);
   };

   const priceGuage = () => {
     setTimeout(() => {
       setRetailCone(false);
       setDiscountCone(true);
       setShowDiscountPrice(true);
       setCouponCone(false);
       setShowCouponPrice(false);
     }, 0);
     setTimeout(() => {
       setDiscountCone(false);
       setCopayCone(true);
       setCouponCone(false);
       setShowCouponPrice(false);
     }, 1500 * discountDataArray.length);
     setTimeout(() => {
       insuranceStatus();
       setShowCopayPrice(true);
     }, 4500);
   };

   const fullPriceGauge = () => {
     setTimeout(() => {
       if (
         copayPrice?.copayPriceMax?.toLowerCase() !== "na" &&
         copayPrice?.copayPriceMax?.toLowerCase() !== "dna"
       ) {
         if (
           !couponData.isLast ||
           parseFloat(copayPrice?.copayPriceMax?.replace("$", "").trim()) >
             parseFloat(
               couponData?.couponPrice?.replace("$", "").trim() ||
                 couponData?.discountPrice?.replace("$", "").trim()
             )
         ) {
           setCopayCone(false);
           setCouponCone(true);
         } else {
           setCopayCone(true);
           setCouponCone(false);
           setShowCouponPrice(false);
         }
       } else {
         if (
           storedInsuranceData?.type === "Z" ||
           storedInsuranceData?.type === "W" ||
           copayPrice?.copayPriceMax?.toLowerCase() === "dna"
         ) {
           setCopayCone(false);
           setCouponCone(true);
         } else {
           setCopayCone(true);
           setCouponCone(false);
           setShowCouponPrice(false);
         }
       }
       setShowCouponPrice(true);
     }, 1000);
   };

   useEffect(() => {
     if (
       copayPrice?.couponNotFoundTitle?.toLowerCase() === "not eligible" ||
       copayPrice?.couponNotFoundTitle?.toLowerCase() === "not available"
     ) {
       setTimeout(() => {
         setShowCouponPrice(true);
       }, 1500);
     }
   }, [copayPrice?.couponNotFoundTitle]);

   const showMinCopayPrice = () => {
     if (copayPriceIsProgress) {
       return "";
     }
     let result =
       copayPrice &&
       copayPrice?.copayPriceMin !== "NA" &&
       copayPrice?.copayPriceMax !== "NA" &&
       copayPrice?.copayPriceMin !== "DNA" &&
       copayPrice?.copayPriceMax !== "DNA"
         ? copayPrice?.copayPriceMin !== copayPrice?.copayPriceMax
           ? `${copayPrice?.copayPriceMin}  to`
           : ""
         : copayPrice?.copayPriceMin === "NA" &&
           copayPrice?.copayPriceMax === "NA"
         ? "Not"
         : copayPrice?.copayPriceMin === "DNA" &&
           copayPrice?.copayPriceMax === "DNA"
         ? "Enter"
         : null;

     if (hasUserSelectedInsurance === "N") {
       result = "Select";
     }
     if (copayPrice?.copayDataFlag?.toLowerCase() === "y") {
       result = "";
     }
     return result;
   };

   const showCopayStatus = () => {
     if (copayPriceIsProgress) {
       return "";
     }
     if (copayPrice?.copayDataFlag?.toLowerCase() === "y") {
       return copayPrice?.copayPriceMin;
     }
     if (hasUserSelectedInsurance === "N") {
       return `Insurance`;
     }
     if (copayPrice) {
       if (
         copayPrice?.copayPriceMin !== "NA" &&
         copayPrice?.copayPriceMax !== "NA" &&
         copayPrice?.copayPriceMin !== "DNA" &&
         copayPrice?.copayPriceMax !== "DNA"
       ) {
         return `${copayPrice?.copayPriceMax}`;
       } else if (
         copayPrice?.copayPriceMin === "NA" &&
         copayPrice?.copayPriceMax === "NA"
       ) {
         return `Covered`;
       } else if (
         copayPrice?.copayPriceMin === "DNA" &&
         copayPrice?.copayPriceMax === "DNA"
       ) {
         return `Insurance`;
       } else {
         return null;
       }
     }
   };

   const showESTLabelForm = () => {
     if (
       (zipData?.zipCode || storedZipData?.zipCode) &&
       // selectedInsurance &&
       // selectedInsurance.id &&
       copayPrice &&
       Object.keys(copayPrice || {}).length &&
       copayPrice?.disclaimerText
     ) {
       if (copayPrice?.copayDataFlag?.toLowerCase() === "y") {
         return "AVG. COPAY*";
       }
       return "EST. COPAY*";
     } else {
       if (copayPrice?.copayDataFlag?.toLowerCase() === "y") {
         return "AVG. COPAY";
       }
       return "EST. COPAY";
     }
   };

   const showCouponDagger = () => {
     if (
       (zipData?.zipCode || storedZipData?.zipCode) &&
       // selectedInsurance &&
       // selectedInsurance.id &&
       couponData &&
       Object.keys(couponData || {}).length &&
       couponData?.disclaimerText
     ) {
       return true;
     } else {
       return false;
     }
   };

   const showCouponStatus = () => {
     if (copayPrice) {
       if (
         couponData &&
         (couponData.couponPrice || couponData.discountPrice) &&
         ((copayPrice?.copayPriceMin !== "NA" &&
           copayPrice?.copayPriceMax !== "NA") ||
           hasUserSelectedInsurance === "N") &&
         copayPrice?.alternateFlag === "N"
       ) {
         return `${couponData.couponPrice || couponData.discountPrice}`;
       } else if (
         ((copayPrice?.copayPriceMin !== "NA" &&
           copayPrice?.copayPriceMax !== "NA") ||
           hasUserSelectedInsurance === "N") &&
         copayPrice?.couponNotFoundTitle?.toLowerCase() === "not available"
       ) {
         return `${copayPrice?.couponNotFoundTitle?.split(" ")[1]}`;
       } else if (
         ((copayPrice?.copayPriceMin !== "NA" &&
           copayPrice?.copayPriceMax !== "NA") ||
           hasUserSelectedInsurance === "N") &&
         copayPrice?.couponNotFoundTitle?.toLowerCase() === "not eligible"
       ) {
         return `${copayPrice?.couponNotFoundTitle?.split(" ")[1]}`;
       } else if (
         copayPrice?.copayPriceMin === "NA" &&
         copayPrice?.copayPriceMax === "NA" &&
         storedInsuranceData?.type === "Z" &&
         selectedProduct.type.toLowerCase() === "g"
       ) {
         return `${couponData.couponPrice || couponData.discountPrice}`;
       }
     }
   };

   const showCouponNotFoundText = () => {
     const result =
       copayPrice &&
       ((copayPrice?.copayPriceMin !== "NA" &&
         copayPrice?.copayPriceMax !== "NA") ||
         hasUserSelectedInsurance === "N") &&
       copayPrice?.alternateFlag === "Y" &&
       (copayPrice?.couponNotFoundTitle?.toLowerCase() === "not eligible" ||
         copayPrice?.couponNotFoundTitle?.toLowerCase() === "not available")
         ? copayPrice?.couponNotFoundTitle?.split(" ")[0]
         : "";
     return result;
   };

   const insuranceStatus = () => {
     props.getInsuranceStatus(true);
   };

   const showDiscountStatusView = () => {
     if (
       discountDataArray &&
       discountDataArray.length &&
       !discountData?.isLast &&
       discountData?.pbmName
     ) {
       return (
         <>
           <div
             className="h1LatoBold"
             style={{
               alignContent: "center",
               alignItems: "center",
               textAlign: "center",
               display: "flex",
               justifyContent: "center",
               fontSize: "18px",
               color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
             }}
           >
             {discountData?.loadingText}
           </div>
           <div
             style={{
               alignContent: "center",
               alignItems: "center",
               textAlign: "center",
               display: "flex",
               justifyContent: "center",
               color: "#FFF",
               fontSize: "22px",
               height: "60px",
             }}
           >
             {discountDataArray.map((item, index) => (
               <div
                 key={index}
                 style={{
                   position: "absolute",
                   marginTop: "10px",
                   height: "60px",
                   color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                   alignItems: "center",
                   transition: "opacity 1s linear",
                   opacity: index === discountData?.index ? 1 : 0,
                   // visibility:
                   //   discountData?.index === index ? "visible" : "hidden",
                   // display: index === discountData?.index ? "block" : "none",
                 }}
               >
                 {`${item.pbmName + " "}`} ({` ` + item.discountPrice + ` `})
               </div>
             ))}
           </div>
         </>
       );
     }
   };
   const showCouponStatusView = () => {
     if (
       (copayPrice &&
         ((copayPrice?.copayPriceMin !== "NA" &&
           copayPrice?.copayPriceMax !== "NA" &&
           copayPrice?.copayPriceMin !== "DNA" &&
           copayPrice?.copayPriceMax !== "DNA" &&
           (!couponData?.isLast ||
             parseFloat(copayPrice?.copayPriceMax?.replace("$", "").trim()) >=
               parseFloat(
                 couponData?.couponPrice?.replace("$", "").trim() ||
                   couponData?.discountPrice?.replace("$", "").trim()
               ))) ||
           (copayPrice?.copayPriceMin === "NA" &&
             copayPrice?.copayPriceMax === "NA" &&
             storedInsuranceData?.type === "Z" &&
             selectedProduct?.type?.toLowerCase() === "g") ||
           (copayPrice?.copayPriceMin === "DNA" &&
             copayPrice?.copayPriceMax === "DNA") ||
           hasUserSelectedInsurance === "N") &&
         copayPrice?.alternateFlag === "N" &&
         couponCone &&
         couponData &&
         Object.keys(couponData || {}).length) ||
       !isShowGaugeFlag
     ) {
       if (!couponData?.isLast) {
         clearTimeout(getSavingsBtn);
         getSavingsBtn = null;
         return (
           <>
             <div
               className="h1LatoBold"
               style={{
                 alignContent: "center",
                 alignItems: "center",
                 textAlign: "center",
                 display: "flex",
                 justifyContent: "center",
                 color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                 fontSize: "18px",
               }}
             >
               {couponData.loadingText}
             </div>
             <div
               style={{
                 alignContent: "center",
                 alignItems: "center",
                 textAlign: "center",
                 display: "flex",
                 justifyContent: "center",
                 color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                 height: "60px",
                 fontSize: "22px",
               }}
             >
               {couponDataArray.map((item, index) => (
                 <div
                   key={index}
                   style={{
                     position: "absolute",
                     color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                     alignItems: "center",
                     transition: "opacity 0.5s linear",
                     opacity: index === couponData.index ? 1 : 0,
                     // visibility:
                     //   couponData.index === index ? "visible" : "hidden",
                     // display: index === couponData.index ? "block" : "none",
                   }}
                 >
                   {`${item.pbmName + " "}`} ({` ` + item.discountPrice + ` `})
                 </div>
               ))}
             </div>
           </>
         );
       }

       if (
         !copayPriceIsProgress &&
         !couponDataIsProgress &&
         couponData?.isLast &&
         (couponData?.couponPrice || couponData?.discountPrice)
       ) {
         if (
           !isHCPTemplate &&
           !getSavingsBtn &&
           savingsBtnAutoForward &&
           showGauge &&
           (selectedProduct?.type?.toLowerCase() !== "b" ||
             hasUserSelectedInsurance === "Y") &&
           organizationInfo?.organizationOptionJson?.sendSavingsFlag?.toLowerCase() ===
             "n"
         ) {
           getSavingsBtn = setTimeout(() => {
             if (savingsBtnAutoForward) {
               getSavings();
               setSavingsBtnAutoForward(false);
             }
           }, 3500);
         }

         console.log("getSavingsBtn", getSavingsBtn);

         return (
           <div
             className="coupon-view"
             style={{
               width: matchesMinWidth ? undefined : "400px",
               paddingBottom: matchesMinWidth ? undefined : "6px",
             }}
           >
             <div className="medium-text">
               <Typography
                 variant="h1LatoBold"
                 sx={{
                   color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                   fontSize: "18px",
                 }}
               >
                 {!isHCPTemplate &&
                 savingsBtnAutoForward &&
                 (selectedProduct?.type?.toLowerCase() !== "b" ||
                   hasUserSelectedInsurance === "Y") &&
                 organizationInfo?.organizationOptionJson?.sendSavingsFlag?.toLowerCase() ===
                   "n"
                   ? "TAKING YOU TO COUPON TO PAY AS LOW AS"
                   : couponData?.loadingText}
               </Typography>
             </div>
             <div
               style={{
                 color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
               }}
               className="large-text"
             >
               {couponData.couponPrice || couponData.discountPrice}
             </div>
             <div>
               {couponData && couponData.disclaimerText ? (
                 <>
                   {isShowGaugeFlag && <sup>†</sup>}
                   <Typography
                     variant="h4LatoRegular"
                     sx={{
                       color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                       //opacity: !isShowBackgroundAssets ? 0.7 : 1,
                       fontSize: "12px",
                     }}
                     dangerouslySetInnerHTML={{
                       __html: couponData?.disclaimerText,
                     }}
                   ></Typography>
                 </>
               ) : null}
             </div>
             <Box style={{ marginTop: "0.5rem" }}>
               {(selectedProduct?.type?.toLowerCase() !== "b" ||
                 hasUserSelectedInsurance === "Y") && (
                 <>
                   {organizationInfo?.organizationOptionJson?.sendSavingsFlag?.toLowerCase() ===
                   "y" ? (
                     <>
                       <Grid container spacing={2}>
                         <Grid item xs={6} md={6}>
                           <Button
                             variant="large"
                             id="getSavingsBtn"
                             onClick={() => {
                               setShowSharePOSPopup(true);
                             }}
                             sx={{
                               color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                               minWidth: "100%",
                               lineHeight: matchesMinWidth
                                 ? "1.5rem"
                                 : undefined,
                               backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                               "&:hover": {
                                 opacity: 1,
                                 color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                                 backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                               },
                             }}
                           >
                             SEND SAVINGS
                           </Button>
                         </Grid>
                         <Grid item xs={6} md={6}>
                           <Button
                             variant="large"
                             id="getSavingsBtn"
                             onClick={() => {
                               getSavings();
                             }}
                             sx={{
                               color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                               minWidth: "100%",
                               lineHeight: matchesMinWidth
                                 ? "1.5rem"
                                 : undefined,
                               backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                               "&:hover": {
                                 opacity: 1,
                                 color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                                 backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                               },
                             }}
                           >
                             VIEW SAVINGS
                           </Button>
                         </Grid>
                       </Grid>
                     </>
                   ) : (
                     <>
                       <Grid container spacing={2}>
                         {isHCPTemplate && (
                           <Grid
                             item
                             xs={isHCPTemplate && !matchesMinWidth ? 6 : 12}
                             md={isHCPTemplate && !matchesMinWidth ? 6 : 12}
                           >
                             <Button
                               variant="large"
                               id="getSavingsBtn"
                               onClick={() => {
                                 if (isHCPTemplate) {
                                   setShowShareHCPPopup(true);
                                 } else {
                                   getSavings();
                                 }
                               }}
                               sx={{
                                 color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                                 minWidth: "100%",
                                 backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                                 "&:hover": {
                                   opacity: 1,
                                   color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                                   backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                                 },
                               }}
                             >
                               {isHCPTemplate
                                 ? "SEND SAVINGS TO PATIENT"
                                 : isPOSTemplate
                                 ? "VIEW SAVINGS"
                                 : "GET SAVINGS!"}
                             </Button>{" "}
                           </Grid>
                         )}
                         <Grid
                           item
                           xs={isHCPTemplate && !matchesMinWidth ? 6 : 12}
                           md={isHCPTemplate && !matchesMinWidth ? 6 : 12}
                         >
                           <Button
                             variant="large"
                             id="getSavingsBtn"
                             onClick={() => {
                               getSavings();
                             }}
                             sx={{
                               height:
                                 isHCPTemplate && !matchesMinWidth
                                   ? "82px"
                                   : "auto",
                               color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                               minWidth: "100%",
                               backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                               "&:hover": {
                                 opacity: 1,
                                 color: `${organizationInfo?.colorSchemeJson?.getSavingsButtonTextColor} !important`,
                                 backgroundColor: `${organizationInfo?.colorSchemeJson?.getSavingsButtonColor}  !important`,
                               },
                             }}
                           >
                             {isHCPTemplate || isPOSTemplate
                               ? "VIEW SAVINGS"
                               : "GET SAVINGS!"}
                           </Button>
                         </Grid>
                       </Grid>
                     </>
                   )}
                 </>
               )}

               {poweredByFlag && poweredByLogo && (
                 <div
                   style={{
                     alignItems: "center",
                     justifyContent: "center",
                     marginTop: "5px",
                     // padding: "10px",
                   }}
                 >
                   <div
                     style={{
                       paddingTop: "1%",
                       paddingBottom: "2%",
                       fontSize: "16px",
                       color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                     }}
                   >
                     powered by
                   </div>
                   <img
                     className="header-logo"
                     alt="cuverd"
                     src={poweredByLogo}
                     style={{
                       width: matchesMinWidth ? "40%" : "30%",
                       //backgroundColor: "#fff",
                       padding: "5px",
                       //width: "30%",
                     }}
                   />
                 </div>
               )}
             </Box>
           </div>
         );
       }
     }
   };

   const NewlineText = () => {
     if (copayPrice && copayPrice?.tierDesc) {
       const text = copayPrice?.tierDesc;
       const newText = text.split("\n").map((str) => (
         <p
           style={{ marginBottom: matchesMinWidth ? "15px" : undefined }}
           key={str}
         >
           {str}
         </p>
       ));
       return newText;
     }
   };
   const xAxisStartPoint = {
     "2": matchesMinWidth ? 50 : 42,
     "3": matchesMinWidth ? 44 : 36,
     "4": matchesMinWidth ? 38 : 30,
     "5": matchesMinWidth ? 32 : 24,
     "6": matchesMinWidth ? 26 : 18,
     "7": matchesMinWidth ? 20 : 12,
     "8": matchesMinWidth ? 18 : 10,
     "9": matchesMinWidth ? 14 : 6,
     "10": matchesMinWidth ? 14 : 6,
   };

   const getTextStartPoint = (text = "", isCopay) => {
     if (isCopay && text?.toLowerCase() === "enter") {
       return matchesMinWidth ? 55 : 36;
     }
     if (isCopay && text?.toLowerCase() === "select") {
       return matchesMinWidth ? 36 : 25;
     }
     if (
       copayPrice?.copayPriceMin === "DNA" &&
       copayPrice?.copayPriceMax === "DNA" &&
       text.toLowerCase() === "insurance"
     ) {
       return 24;
     } else if (text.toLowerCase() === "insurance") {
       return 18;
     }

     if (text.toLowerCase() === "eligible") {
       return 24;
     }

     if (text.toLowerCase() === "enter") {
       return 22;
     }

     let characterCount = 0;
     if (text.toLowerCase().replace(/[^i]/g, "").length) {
       characterCount += text.toLowerCase().replace(/[^i]/g, "").length;
     }
     if (text.toLowerCase().replace(/[^1]/g, "").length) {
       characterCount += text.toLowerCase().replace(/[^1]/g, "").length;
     }
     if (text.toLowerCase().replace(/[^.]/g, "").length) {
       characterCount += text.toLowerCase().replace(/[^.]/g, "").length + 1;
     }
     if (text.toLowerCase().replace(/[^ ]/g, "").length) {
       characterCount += text.toLowerCase().replace(/[^ ]/g, "").length + 1;
     }
     if (text.toLowerCase().replace(/[^*]/g, "").length) {
       characterCount += text.toLowerCase().replace(/[^*]/g, "").length + 1;
     }
     if (text.includes(" to")) {
       characterCount += 2;
     }
     const quotient = Math.floor(characterCount / 2);
     const remainder = characterCount % 2;
     return xAxisStartPoint[text.length - (quotient + remainder)];
   };

   const getSavings = () => {
     if (couponData) {
       clearTimeout(getSavingsBtn);
       getSavingsBtn = null;
       setSavingsBtnAutoForward(false);

       if (couponData.couponType === "M" || couponData.discountType === "M") {
         storeAppData("brandedInfo", {
           productDetailId: productDetailId,
           zipCode: storedZipData?.zipCode || zipData?.zipCode,
           name: selectedProduct?.productName,
           insuranceId: selectedInsurance?.id,
           quantity: appQuantity,
           offerId: couponData.offerId,
         });
         onSavingsClick("couponDetails");
       } else if (
         couponData.couponType === "P" ||
         couponData.discountType === "P"
       ) {
         onSavingsClick("genericList");
       }
     }
   };

   useEffect(() => {
     if (
       !retailDataStatus &&
       (retailData === null ||
         (retailData && Object.keys(retailData || {}).length === 0)) &&
       !isProgress &&
       retailMessage
     ) {
       setGaugeInit(false);
     }

     if (
       !discountDataStatus &&
       ((discountDataObj && Object.keys(discountDataObj || {}).length === 0) ||
         discountDataObj === null) &&
       !isProgress &&
       discountMessage
     ) {
       setGaugeInit(false);
     }
   }, [
     retailData,
     isProgress,
     retailDataStatus,
     discountDataStatus,
     isProgress,
     discountDataObj,
   ]);

   return (
     <div
       className="gauge-container"
       style={{ width: matchesMinWidth ? "280px" : undefined }}
     >
       {isShowGaugeFlag ? (
         <>
           <div
             className="donut-graph"
             style={{
               width: matchesMinWidth ? "280px" : undefined,
               height: matchesMinWidth ? "140px" : undefined,
               marginLeft: "auto",
               marginRight: "auto",
               marginBottom: matchesMinWidth ? "15px" : undefined,
             }}
           >
             <div
               className="semi-donut"
               style={{
                 "--degree": 180,
                 "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge4Color}`,
                 "--top": "40%",
                 "--left": "-28%",
                 "--transform": "-116deg",
                 "--animation": "1s",
                 width: matchesMinWidth ? "280px" : undefined,
                 height: matchesMinWidth ? "140px" : undefined,
                 borderWidth: matchesMinWidth ? "4.2rem" : undefined,
                 borderBottomWidth: matchesMinWidth ? "4.1rem" : "4.999999rem",
               }}
             ></div>
             <SVGCurvedText
               title="COUPON"
               titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
               getSavings={
                 couponCone && couponData?.isLast && !isHCPTemplate
                   ? getSavings
                   : undefined
               }
               bottom={matchesMinWidth ? 10 : 30}
               showDagger={
                 // showCopayStatus() === "Covered"
                 //   ? false
                 //   :
                 showCouponDagger() ? true : false
               }
               unicode="&#8224;"
               right={matchesMinWidth ? -6 : -22}
               fontSize={22}
               textStartPoint={18}
               degree={69}
             />
             <SVGCurvedText
               titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
               title={showESTLabelForm()}
               top={matchesMinWidth ? 8 : 14}
               right={matchesMinWidth ? 54 : 70}
               fontSize={21}
               degree={23}
               textStartPoint={18}
               id="copay_quadrant"
             />
             <div
               className="semi-donut"
               style={{
                 "--degree": 135,
                 "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
                 "--top": "41%",
                 "--left": "-33%",
                 "--transform": "-111deg",
                 "--animation": "2s",
                 width: matchesMinWidth ? "280px" : undefined,
                 height: matchesMinWidth ? "140px" : undefined,
                 borderWidth: matchesMinWidth ? "4.2rem" : undefined,
               }}
             ></div>
             <div
               className="semi-donut"
               style={{
                 "--degree": 90,
                 "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge2Color}`,
                 "--top": "43%",
                 "--left": "-30%",
                 "--transform": "-116deg",
                 "--animation": "3s",
                 width: matchesMinWidth ? "280px" : undefined,
                 height: matchesMinWidth ? "140px" : undefined,
                 borderWidth: matchesMinWidth ? "4.2rem" : undefined,
                 borderBottomWidth: matchesMinWidth ? "4.1rem" : "4.999999rem",
               }}
             ></div>
             <SVGCurvedText
               titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
               title={
                 selectedProduct && selectedProduct.type.toLowerCase() === "g"
                   ? "RETAIL"
                   : "DISCOUNT"
               }
               textStartPoint={getTextStartPoint(
                 selectedProduct && selectedProduct.type.toLowerCase() === "g"
                   ? "RETAIL"
                   : "DISCOUNT"
               )}
               left={
                 matchesMinWidth && selectedProduct?.type?.toLowerCase() !== "g"
                   ? 51
                   : matchesMinWidth &&
                     selectedProduct?.type?.toLowerCase() === "g"
                   ? 55
                   : 70
               }
               top={
                 matchesMinWidth && selectedProduct?.type?.toLowerCase() !== "g"
                   ? 8
                   : matchesMinWidth &&
                     selectedProduct?.type?.toLowerCase() === "g"
                   ? 7
                   : 12
               }
               fontSize={21}
               degree={matchesMinWidth ? 336 : 338}
             />
             <SVGCurvedText
               left={matchesMinWidth ? -7 : -24}
               title={
                 selectedProduct && selectedProduct.type.toLowerCase() === "g"
                   ? ""
                   : "RETAIL"
               }
               textStartPoint={getTextStartPoint(
                 selectedProduct && selectedProduct.type.toLowerCase() === "g"
                   ? ""
                   : "RETAIL"
               )}
               bottom={matchesMinWidth ? 12 : 44}
               fontSize={matchesMinWidth ? 23 : 22}
               degree={292}
               titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
             />
             <div
               className="semi-donut"
               style={{
                 "--degree": 45,
                 "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color}`,
                 "--top": "44%",
                 "--left": "-24%",
                 "--transform": "-116deg",
                 "--animation": "1s",
                 width: matchesMinWidth ? "280px" : undefined,
                 height: matchesMinWidth ? "140px" : undefined,
                 borderWidth: matchesMinWidth ? "4.2rem" : undefined,
               }}
             ></div>
             {/* <img
              src={rightcorner}
              alt="righarc"
              style={{ zIndex: retailCone ? 0 : undefined }}
              className={
                matchesMinWidth ? "mobile-right-curved-arc" : "right-curved-arc"
              }
            /> */}
             <RightCustomSvgIcon
               className={
                 matchesMinWidth
                   ? retailCone
                     ? "mobile-right-curved-arc z-index-zero"
                     : "mobile-right-curved-arc"
                   : retailCone
                   ? "right-curved-arc z-index-zero"
                   : "right-curved-arc"
               }
               color={`${organizationInfo?.colorSchemeJson?.gaugeColor?.backgroundColor}`}
             />
             {/* <img
              src={leftcorner}
              alt="righarc"
              style={{ zIndex: couponCone ? 0 : undefined }}
              className={
                matchesMinWidth ? "mobile-left-curved-arc" : "left-curved-arc"
              }
            /> */}

             <LeftCustomSvgIcon
               className={
                 matchesMinWidth
                   ? couponCone
                     ? "mobile-left-curved-arc z-index-zero"
                     : "mobile-left-curved-arc"
                   : couponCone
                   ? "left-curved-arc z-index-zero"
                   : "left-curved-arc"
               }
               color={`${organizationInfo?.colorSchemeJson?.gaugeColor?.backgroundColor}`}
             />
           </div>
           <div
             className="cone-container"
             style={{
               "--width": matchesMinWidth ? mobileFullWidth : fullWidth,
               "--height": matchesMinWidth ? mobileFullWidth : fullWidth,
               // left: matches400Width ? "10vw" : undefined,
               marginLeft: "auto",
               marginRight: "auto",
               left: 0,
               right: 0,
             }}
           >
             <span
               className="cone-area"
               style={{
                 "--width": matchesMinWidth ? mobileFullWidth : fullWidth,
                 "--height": matchesMinWidth ? mobileFullWidth : fullWidth,
               }}
             >
               <span
                 className={retailCone ? "cone-view" : "hide-cone"}
                 style={{
                   "--fullClip": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--halfClip": matchesMinWidth ? mobileHalfWidth : halfWidth,
                   "--width": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--height": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--background-color": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color}`,
                 }}
               ></span>
               <span
                 className={discountCone ? "cone-view" : "hide-cone"}
                 style={{
                   "--fullClip": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--halfClip": matchesMinWidth ? mobileHalfWidth : halfWidth,
                   "--width": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--height": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--background-color": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge2Color}`,
                 }}
               ></span>
               <span
                 className={copayCone ? "cone-view" : "hide-cone"}
                 style={{
                   "--fullClip": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--halfClip": matchesMinWidth ? mobileHalfWidth : halfWidth,
                   "--width": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--height": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--background-color": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
                 }}
               ></span>
               <span
                 className={couponCone ? "cone-view" : "hide-cone"}
                 style={{
                   "--fullClip": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--halfClip": matchesMinWidth ? mobileHalfWidth : halfWidth,
                   "--width": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--height": matchesMinWidth ? mobileFullWidth : fullWidth,
                   "--background-color": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge4Color}`,
                 }}
               ></span>
             </span>
           </div>
           <div
             className="price-container"
             style={{
               width: matchesMinWidth ? "280px" : undefined,
               height: matchesMinWidth ? "140px" : undefined,
               left: matchesMinWidth ? "10vw" : undefined,
             }}
           >
             <Box
               sx={{
                 position: "relative",
                 height: matchesMinWidth ? "140px" : "12.5rem",
                 width: matchesMinWidth ? "280px" : "25rem",
               }}
             >
               {showRetailPrice &&
               Object.keys(retailData || {}).length &&
               retailData.regularPrice ? (
                 <SVGCurvedText
                   title={retailData.regularPrice}
                   left={matchesMinWidth ? -80 : -66}
                   bottom={matchesMinWidth ? 18 : 58}
                   fontSize={matchesMinWidth ? 26 : 24}
                   degree={matchesMinWidth ? 291 : 292}
                   textStartPoint={getTextStartPoint(retailData.regularPrice)}
                   titleColor={
                     `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     // retailCone
                     //   ? !isShowBackgroundAssets
                     //     ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //     : "#fff"
                     //   : !isShowBackgroundAssets
                     //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //   : "rgb(200,200,200)"
                   }
                   fontFamily="Lato-Regular"
                 />
               ) : null}
               {showDiscountPrice && Object.keys(discountData || {}).length ? (
                 <SVGCurvedText
                   title={
                     discountData?.discountPrice || discountData?.regularPrice
                   }
                   left={matchesMinWidth ? -8 : 48}
                   top={matchesMinWidth ? -18 : -26}
                   fontSize={matchesMinWidth ? 26 : 24}
                   degree={matchesMinWidth ? 334 : 337}
                   fontFamily="Lato-Regular"
                   titleColor={
                     `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     // discountCone
                     //   ? !isShowBackgroundAssets
                     //     ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //     : "#fff"
                     //   : !isShowBackgroundAssets
                     //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //   : "rgb(200,200,200)"
                   }
                   textStartPoint={getTextStartPoint(
                     discountData?.discountPrice || discountData?.regularPrice
                   )}
                 />
               ) : null}
               {showCopayPrice && Object.keys(copayPrice || {}).length ? (
                 <SVGCurvedText
                   showSecondCurve={true}
                   secondCurveTitle={showMinCopayPrice()}
                   secondCurveRight={
                     matchesMinWidth
                       ? 73
                       : showCopayStatus() === "Covered"
                       ? 16
                       : 40
                   }
                   secondCurveTop={matchesMinWidth ? -38 : -50}
                   secondCurveFontSize={matchesMinWidth ? 24 : 22}
                   secondCurveDegree={matchesMinWidth ? 23 : 24}
                   secondCurveTextStartPoint={getTextStartPoint(
                     showMinCopayPrice(),
                     "isCopay"
                   )}
                   secondTitleColor={
                     `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     // copayCone
                     //   ? !isShowBackgroundAssets
                     //     ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //     : "#fff"
                     //   : !isShowBackgroundAssets
                     //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //   : "rgb(200,200,200)"
                   }
                   titleColor={
                     `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     // copayCone
                     //   ? !isShowBackgroundAssets
                     //     ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //     : "#fff"
                     //   : !isShowBackgroundAssets
                     //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //   : "rgb(200,200,200)"
                   }
                   fontFamily="Lato-Regular"
                   secondTitleFontFamily="Lato-Regular"
                   title={showCopayStatus()}
                   right={
                     matchesMinWidth
                       ? 77
                       : showCopayStatus() === "Covered"
                       ? 27
                       : 50
                   }
                   top={
                     matchesMinWidth
                       ? -19
                       : showCopayStatus() === "Covered"
                       ? -22
                       : -28
                   }
                   fontSize={matchesMinWidth ? 24 : 22}
                   showInfoICon={
                     !copayPriceIsProgress &&
                     copayPrice?.copayPriceMin === "DNA" &&
                     copayPrice?.copayPriceMax === "DNA"
                       ? true
                       : copayPrice &&
                         copayPrice?.tierDesc &&
                         copayPrice?.tierTitle &&
                         !copayPriceIsProgress
                       ? true
                       : false
                   }
                   onButtonClick={() => {
                     if (
                       hasUserSelectedInsurance === "N" ||
                       (copayPrice?.copayPriceMin === "DNA" &&
                         copayPrice?.copayPriceMax === "DNA")
                     ) {
                       openInsurance("select_insurance");
                     } else {
                       setOpenInfoDialog(true);
                     }
                   }}
                   textStartPoint={getTextStartPoint(showCopayStatus())}
                   degree={
                     copayPrice &&
                     copayPrice?.copayPriceMin !== "NA" &&
                     copayPrice?.copayPriceMax !== "NA" &&
                     copayPrice?.copayPriceMin !== "DNA" &&
                     copayPrice?.copayPriceMax !== "DNA" &&
                     copayPrice?.alternateFlag === "N"
                       ? 24
                       : showCopayStatus() === "Covered"
                       ? 26
                       : 23
                   }
                 />
               ) : null}
               {!copayPriceIsProgress &&
               (showCouponPrice ||
                 (copayPrice &&
                   copayPrice?.couponFoundFlag?.toLowerCase() === "n")) &&
               ((copayPrice &&
                 copayPrice?.alternateFlag === "N" &&
                 Object.keys(couponData || {}).length) ||
                 (copayPrice && copayPrice?.alternateFlag === "Y")) ? (
                 <SVGCurvedText
                   showSecondCurve={true}
                   secondCurveTitle={showCouponNotFoundText()}
                   getSavings={
                     couponCone && couponData?.isLast && !isHCPTemplate
                       ? getSavings
                       : undefined
                   }
                   secondCurveRight={matchesMinWidth ? -12 : -90}
                   secondCurveTop={matchesMinWidth ? 49 : 80}
                   secondCurveFontSize={23}
                   secondCurveDegree={matchesMinWidth ? 69 : 71}
                   secondCurveTextStartPoint={getTextStartPoint(
                     showCouponNotFoundText()
                   )}
                   secondTitleColor={
                     `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     // couponCone
                     //   ? !isShowBackgroundAssets
                     //     ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //     : "#fff"
                     //   : !isShowBackgroundAssets
                     //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //   : "rgb(200,200,200)"
                   }
                   secondTitleFontFamily="Lato-Regular"
                   title={showCouponStatus()}
                   titleColor={
                     `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     // couponCone
                     //   ? !isShowBackgroundAssets
                     //     ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //     : "#fff"
                     //   : !isShowBackgroundAssets
                     //   ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`
                     //   : "rgb(200,200,200)"
                   }
                   right={matchesMinWidth ? 2 : -70}
                   fontFamily="Lato-Regular"
                   bottom={matchesMinWidth ? 22 : 54}
                   fontSize={matchesMinWidth ? 24 : 22}
                   degree={70}
                   textStartPoint={getTextStartPoint(showCouponStatus())}
                 />
               ) : null}
             </Box>
           </div>
         </>
       ) : null}
       {isProgress && (
         <div
           style={{
             color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
           }}
           className="loading"
         >
           LOADING...
         </div>
       )}
       {/* {!retailDataStatus &&
        (retailData === null ||
          (retailData && Object.keys(retailData).length === 0)) &&
        !isProgress &&
        retailMessage && <div className="error-msg">{retailMessage} </div>} */}
       {!discountDataStatus &&
         ((discountDataObj &&
           Object.keys(discountDataObj || {}).length === 0) ||
           discountDataObj === null) &&
         !isProgress &&
         discountMessage && (
           <div
             style={{
               color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
             }}
             className="error-msg"
           >
             {discountMessage}
           </div>
         )}
       {showDiscountStatusView()}
       {showCouponStatusView()}
       {copayCone &&
       copayPrice &&
       !copayPriceIsProgress &&
       hasUserSelectedInsurance === "Y" &&
       copayPrice?.tierTitle &&
       copayPrice?.couponNotFoundTitle?.toLowerCase() !== "not eligible" &&
       copayPrice?.couponNotFoundTitle?.toLowerCase() !== "not available" ? (
         <Box>
           <div
             className="coupon-view"
             style={{ width: matchesMinWidth ? undefined : "400px" }}
           >
             <div className="tier-title">
               <Typography
                 // variant={
                 //   copayPrice?.copayPriceMax?.toLowerCase() === "na" &&
                 //     copayPrice?.copayPriceMin?.toLowerCase() === "na"
                 //     ? "h1LatoBold"
                 //     : "h4LatoRegular"
                 // }
                 variant="h1LatoBold"
                 sx={{
                   color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                   fontSize: "18px",
                   //opacity: !isShowBackgroundAssets ? 0.7 : 1,
                 }}
               >
                 {parseFloat(
                   copayPrice?.copayPriceMax?.replace("$", "").trim()
                 ) <
                 parseFloat(
                   couponData?.couponPrice?.replace("$", "").trim() ||
                     couponData?.discountPrice?.replace("$", "").trim()
                 )
                   ? copayPrice?.copayPriceBetterText
                   : copayPrice?.tierTitle}
               </Typography>
             </div>
             {copayPrice?.formularyText && (
               <div className="tier-title">
                 <Typography
                   variant="h1LatoBold"
                   sx={{
                     color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                     letterSpacing: "0.6px",
                     fontSize: matchesMinWidth ? "22px" : undefined,
                   }}
                 >
                   {copayPrice?.formularyText}
                 </Typography>
               </div>
             )}
             {copayPrice?.disclaimerText && (
               <div className="small-text">
                 <Typography
                   variant={
                     copayPrice?.copayPriceMax?.toLowerCase() === "na" &&
                     copayPrice?.copayPriceMin?.toLowerCase() === "na"
                       ? "h2LatoBold"
                       : "h4LatoRegular"
                   }
                   sx={{
                     color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                     //opacity: !isShowBackgroundAssets ? 0.7 : 1,
                     fontSize: "12px",
                   }}
                 >
                   {copayPrice?.disclaimerText ? `*` : null}
                   {copayPrice?.disclaimerText}
                 </Typography>
               </div>
             )}
           </div>
         </Box>
       ) : null}
       <Dialog
         open={openInfoDialog}
         onClose={() => setOpenInfoDialog(false)}
         className="app-dialog"
       >
         <DialogContent
           sx={{
             padding: matchesMinWidth ? "26px" : "28px",
             textAlign: "center",
           }}
         >
           <Box sx={{ marginTop: "10px" }} my={matchesMinWidth ? 1 : undefined}>
             <Typography
               variant="h5LatoBlack"
               sx={{
                 letterSpacing: "0.38px",
                 color: `${organizationInfo?.colorSchemeJson?.stepsTextColor}`,
                 //opacity: !isShowBackgroundAssets ? 0.7 : 1,
                 fontSize: "24px",
               }}
             >
               {copayPrice?.tierTitle}
             </Typography>
           </Box>

           <Box px={1} py={matchesMinWidth ? 0 : 1}>
             <Typography
               className={
                 copayPrice?.copayDataFlag?.toLowerCase() === "n"
                   ? "info-content"
                   : ""
               }
               variant="h3LatoRegular"
               sx={{ lineHeight: matchesMinWidth ? "1.5rem" : "1.5rem" }}
             >
               {NewlineText()}
             </Typography>
           </Box>

           {copayPrice?.copayDataFlag?.toLowerCase() === "y" &&
             copayPrice?.copayDatajson && (
               <>
                 <Box px={0} py={0} my={matchesMinWidth ? 1 : undefined}>
                   <Typography
                     variant="h5LatoBlack"
                     sx={{
                       letterSpacing: "0.38px",
                       color: "#83D712",
                       fontSize: "24px",
                     }}
                   >
                     {copayPrice?.copayDatajson?.copayDataTitle}
                   </Typography>
                 </Box>
                 <Box
                   px={1}
                   py={1}
                   sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     alignContent: "center",
                     alignItems: "center",
                   }}
                 >
                   <Typography
                     // className="info-content"
                     variant="h3LatoBold"
                     component={"div"}
                     sx={{
                       lineHeight: matchesMinWidth ? "1.5rem" : "2rem",
                       paddingRight: "10px",
                     }}
                   >
                     {copayPrice?.copayDatajson?.averageCopayLabel}:{" "}
                     {copayPrice?.copayDatajson?.averagePrice}
                   </Typography>

                   <Typography
                     component={"div"}
                     // className="info-content"
                     variant="h3LatoBold"
                     sx={{ lineHeight: matchesMinWidth ? "1.5rem" : "2rem" }}
                   >
                     {copayPrice?.copayDatajson?.percentile75thPriceLabel}:{" "}
                     {copayPrice?.copayDatajson?.percentile75thPrice}
                   </Typography>
                 </Box>
                 <Box px={1} py={2}>
                   <Typography
                     //className="info-content"
                     variant="h3LatoRegular"
                     sx={{ lineHeight: matchesMinWidth ? "1.5rem" : "1.5rem" }}
                   >
                     {copayPrice?.copayDatajson?.copayDisclaimerText}
                   </Typography>
                 </Box>
               </>
             )}
           <Button
             variant="outline"
             // className="info-done-button"
             sx={{ textTransform: "uppercase", marginBottom: "10px" }}
             onClick={() => setOpenInfoDialog(false)}
           >
             Done
           </Button>
         </DialogContent>
       </Dialog>

       {showSharePOSPopup && (
         <SendSavingsPOS
           productType={
             couponData?.couponType === "M" || couponData?.discountType === "M"
               ? "branded"
               : couponData?.couponType === "P" ||
                 couponData?.discountType === "P"
               ? "generic"
               : null
           }
           setShowSharePOSPopup={setShowSharePOSPopup}
           sharePOSCoupon={showSharePOSPopup}
           couponData={couponDataObj}
         />
       )}

       {showShareHCPPopup && (
         <ShareHCPApp
           setShowSharePopup={setShowShareHCPPopup}
           shareCoupon={showShareHCPPopup}
           shareApp={false}
           couponData={couponDataObj}
         />
       )}
     </div>
   );
};

function mapStatetoProps(state) {
  return {
    isProgress:
      state.retailPrice.isProgress ||
      state.discountPrice.isProgress ||
      state.copayPrice.isProgress,
    retailData: state.retailPrice.data,
    retailDataStatus: state.retailPrice.success,
    discountDataIsProgress: state.discountPrice.isProgress,
    discountDataStatus: state.discountPrice.success,
    selectedProduct: state.home.selectedProduct,
    discountDataObj: state.discountPrice.data,
    discountDataArray: state.discountPrice.dataArray,
    selectedInsurance: state.insuranceList.selectedInsurance,
    copayPrice: state.copayPrice.data,
    copayPriceIsProgress: state.copayPrice.isProgress,
    couponDataObj: state.couponPrice.data,
    couponDataArray: state.couponPrice.dataArray,
    couponLowestPrice: state.couponPrice.lowestPrice,
    couponDataIsProgress: state.couponPrice.isProgress,
    resetId: state.home.resetId,
    appQuantity: state.productDetails.appQuantity,
    productDetailId: state.productDetails.productDetailId,
    zipData: state.zipData.data,
    authData: state.authentication.authData || {},
    organizationInfo: state.organizationInfo.data,
    retailMessage: state.retailPrice.message,
    discountMessage: state.discountPrice.message,
    hasUserSelectedInsurance: state.insuranceList.hasUserSelectedInsurance,
  };
}

const actionCreators = {
  storeAppData: (type, value) => homeActions.storeAppData(type, value),
  getPharmacyGroup: (value) => gaugeActions.getPharmacyGroup(value),
  updateCouponPrice: (value) => gaugeActions.updateCouponPrice(value),
  updateDiscountPrice: (value) => homeActions.updateDiscountPrice(value),
  copayPriceReset: () => gaugeActions.copayPriceReset(),
  couponPriceReset: () => gaugeActions.couponPriceReset(),
};

export default connect(mapStatetoProps, actionCreators)(SearchGaugeView);
